export default "__VITE_ASSET__HuBiDMPR__"